// module imports
import eventLogger from 'modules/Logger'
// constant imports
import { AUDIO_ELEMENT_ID } from 'constants/General'
import { ADD_RECEIVED_STREAM_MERGED } from 'redux/Sessions/constants'

const audioElement = () => document.getElementById(AUDIO_ELEMENT_ID)

export const removeAudioStream = () => {
  eventLogger.info('remove_audio_stream')

  const element = audioElement()
  if (element) {
    element.srcObject = undefined
  }
}

export const startAlreadyMergedAudioStream = (getState) => {
  eventLogger.info('starting_already_merged_audio_stream')
  const element = audioElement()
  const { sessions } = getState()
  const { receivedStream } = sessions.merged

  removeAudioStream()

  if (element && receivedStream) {
    eventLogger.info('start_already_merged_audio_stream')

    element.srcObject = receivedStream
    element.play()
  }
}

export const startAudioStream = (connection, id, getState) => {
  if (!connection) return

  eventLogger.info('starting_audio_stream')

  removeAudioStream()

  const element = audioElement()

  const receivedTrack = connection.getReceivers?.()?.[0]?.track

  if (receivedTrack) {
    const receivedStream = new MediaStream()
    receivedStream.addTrack(receivedTrack)
    element.srcObject = receivedStream
  }

  // eslint-disable-next-line no-param-reassign
  connection.ontrack = (data) => {
    eventLogger.info('try_start_audio_stream')

    const { sessions } = getState()
    const session = sessions.list[id]

    if (!session || !session.merged) {
      eventLogger.info('start_audio_stream')

      element.srcObject = undefined
      element.srcObject = data.streams[0] // eslint-disable-line prefer-destructuring
      element.play()
    } else {
      startAlreadyMergedAudioStream(getState)
    }
  }
}

export const endAudioStream = () => {
  eventLogger.info('end_stream')
  const element = audioElement()

  if (element?.srcObject) {
    element.srcObject = undefined
  }
}

export const startConferenceAudioStream = (sessions = [], dispatch) => {
  // validate input
  if (sessions.length < 2) return
  eventLogger.info('start_conference_audio_stream', { sessions })

  const trueSessions = sessions.filter((session) => !!session)

  // get all received tracks from the sessions to merge
  const receivedTracks = []
  trueSessions.forEach((session) => {
    session.connection.getReceivers().forEach((receiver) => {
      receivedTracks.push(receiver.track)
    })
  })

  // use the Web Audio API to mix the received tracks
  const context = new AudioContext()
  const allReceivedMediaStreams = new MediaStream()

  trueSessions.forEach((session) => {
    const mixedOutput = context.createMediaStreamDestination()

    session.connection.getReceivers().forEach((receiver) => {
      receivedTracks.forEach((track) => {
        allReceivedMediaStreams.addTrack(receiver.track)

        if (receiver.track.id !== track.id) {
          const sourceStream = context.createMediaStreamSource(
            new MediaStream([track]),
          )
          sourceStream.connect(mixedOutput)
        }
      })
    })

    // mix local audio in with all the received audio
    session.connection.getSenders().forEach((sender) => {
      const sourceStream = context.createMediaStreamSource(
        new MediaStream([sender.track]),
      )
      sourceStream.connect(mixedOutput)
    })

    const sender = session.connection.getSenders()[0]
    sender && sender.replaceTrack(mixedOutput.stream.getTracks()[0])
  })

  // play all streams
  const element = audioElement()

  dispatch({
    type: ADD_RECEIVED_STREAM_MERGED,
    payload: allReceivedMediaStreams,
  })

  if (element) {
    element.srcObject = allReceivedMediaStreams
    element.play()
  }
}
